import { z } from 'zod/mini';
import type { GameSettings, PanoRef, RevealedLocation } from './game';
import { latLngSchema } from './game';
import type { LatLng } from './geo';

export interface SoloRoundResult {
  location: RevealedLocation;
  guess: LatLng | null;
  distanceKm: number | null;
  points: number;
  /** In country mode: the country the guess was in (null in the sea, or in pin mode). */
  guessCountry: string | null;
}

export interface SoloRound {
  index: number;
  pano: PanoRef;
  /** Epoch ms at which guessing starts (after the round intro). */
  startedAt: number;
  endsAt: number | null;
  /** The marker placed but not submitted yet; it counts if time runs out. */
  pin: LatLng | null;
  result: SoloRoundResult | null;
}

export interface SoloGame {
  id: string;
  settings: GameSettings;
  status: 'playing' | 'finished';
  totalScore: number;
  /** The challenge this game is played in (see ChallengeInfo), if any. */
  challengeId: string | null;
  /** Rounds that have been started so far, in order. */
  rounds: SoloRound[];
  createdAt: number;
  serverTime: number;
}

export const soloGuessSchema = z.object({
  guess: z.nullable(latLngSchema),
});

export type SoloGuessPayload = z.infer<typeof soloGuessSchema>;

export const soloPinSchema = z.object({ guess: latLngSchema });
